import { render } from "./ButtonLayer.vue?vue&type=template&id=740acd28&scoped=true"
import script from "./ButtonLayer.vue?vue&type=script&lang=js"
export * from "./ButtonLayer.vue?vue&type=script&lang=js"

import "./ButtonLayer.vue?vue&type=style&index=0&id=740acd28&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740acd28"]])

export default __exports__